import { useState } from "react";
import Dialog from "../../components/Dialog";
import recruiter1 from "../../assets/avatars/recruiter_1.webp";
import recruiter2 from "../../assets/avatars/recruiter_2.webp";
import recruiter3 from "../../assets/avatars/recruiter_3.webp";
import recruiter4 from "../../assets/avatars/recruiter_4.webp";
import recruiter5 from "../../assets/avatars/recruiter_5.webp";
import recruiter6 from "../../assets/avatars/recruiter_6.webp";
import recruiter7 from "../../assets/avatars/recruiter_7.webp";
import { Profile } from "../../services/profile/profileModel";
import { RecordType, RecorderConfig } from "./RecordPage";
import { Capsule } from "../../services/capsule/capsuleModel";
import { useTranslation } from "react-i18next";

enum Step {
  Advices, // NOTE : no more Advices step for the moment
  Interlocutor,
  Notes,
}

const INTERLOCUTORS = [
  recruiter1,
  recruiter2,
  recruiter3,
  recruiter4,
  recruiter5,
  recruiter6,
  recruiter7,
];

export const InterlocutorChoiceComponent = ({
  onChoice,
  onNext,
  onPrevious,
}: {
  onChoice: (interlocutor: string | null) => void;
  onNext?: () => void;
  onPrevious?: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="popup_head">
        <h2 className="popup_title">
          {t("record:config.CHOOSE_AVATAR_TITLE")}
        </h2>
        <p className="body">{t("record:config.CHOOSE_AVATAR_DESCRIPTION")}</p>
      </div>

      <div className="popup_body">
        <div className="lrow --center--h">
          <button className="btn--choose-avatar" onClick={() => onChoice(null)}>
            {t("record:config.NO_AVATAR")}
          </button>
          {INTERLOCUTORS.map((src) => (
            <button
              className="btn--choose-avatar"
              key={src}
              onClick={() => onChoice(src)}
            >
              <img src={src} />
            </button>
          ))}
        </div>
      </div>
      {onNext && (
        <div className="popup_footer">
          {onPrevious && (
            <button className="btn--grey" onClick={onPrevious}>
              {t("record:config.PREVIOUS_BUTTON")}
            </button>
          )}
          <button className="btn" onClick={onNext}>
            {t("record:config.CONTINUE_BUTTON")}
          </button>
        </div>
      )}
    </div>
  );
};

const RecorderConfigurationComponent = ({
  capsule,
  profile,
  onClose,
}: {
  type: RecordType;
  capsule?: Capsule;
  profile?: Profile;
  onClose(values: Partial<RecorderConfig>): void;
}) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(Step.Interlocutor);

  const [interlocutor, setInterlocutor] = useState<null | string>(null);
  const [notes, setNotes] = useState(profile?.note ?? capsule?.note ?? "");

  return (
    <Dialog
      className="--branded"
      onClose={() =>
        onClose({
          interlocutor,
          initialized: true,
          showNotes: false,
        })
      }
    >
      <div>
        {step === Step.Interlocutor && (
          <InterlocutorChoiceComponent
            onChoice={(choice) => {
              setInterlocutor(choice);
              setStep(Step.Notes);
            }}
            onNext={() => setStep(Step.Notes)}
          />
        )}
        {step === Step.Notes && (
          <div>
            <div className="popup_head">
              <h2 className="popup_title">
                {t("record:config.NOTES_HELP_TITLE")}
              </h2>
            </div>
            <div className="popup_body">
              <textarea
                className="textarea"
                onChange={(e) => setNotes(e.target.value)}
                value={notes}
              />
            </div>

            <div className="popup_footer">
              <button
                className="btn--grey"
                onClick={() => setStep(Step.Interlocutor)}
              >
                {t("record:config.PREVIOUS_BUTTON")}
              </button>
              <button
                className="btn"
                onClick={() =>
                  onClose({
                    interlocutor,
                    notes,
                    initialized: true,
                    showNotes: notes.length > 0,
                  })
                }
              >
                {t("record:config.READY_BUTTON")}
              </button>
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default RecorderConfigurationComponent;
